import { useQuery } from "@apollo/client";

import { ScanProvider } from "types/generated";

import { GET_SCAN_PROVIDER_SCHEMA } from "./gql";

const useScanProviderSchema = () => {
  const { data, error, loading } = useQuery(GET_SCAN_PROVIDER_SCHEMA, {
    variables: { provider: ScanProvider.Aws },
  });

  const schema = data?.scanProviderSchemas[0];

  return {
    providerVersions: schema?.majorVersions ?? [],
    regions: schema?.configSchema.regions ?? [],
    resourceTypes: schema?.listSchemas ?? [],
    error,
    loading,
  };
};

export default useScanProviderSchema;
